import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["triggerRef", "clickHandler"];
import React, { forwardRef } from 'react';
import { Icon } from '../Icon';
import { Play, Spotify } from '../Icons';
import { Box } from '../Layout';
import { MusicManager } from '../MusicManager';
import { ShapeButton } from './ShapeButton';
const PlayShapeContainer = Box;
export const PlayShapeButton = forwardRef(function PlayShapeButton(props, ref) {
  return React.createElement(MusicManager, _extends({
    ref: ref
  }, props), _ref => {
    let {
        triggerRef,
        clickHandler
      } = _ref,
      extraProps = _objectWithoutProperties(_ref, _excluded);
    return React.createElement(PlayShapeContainer, extraProps, React.createElement(ShapeButton, _extends({
      ref: triggerRef,
      onClick: clickHandler,
      shapeColor: props.isPlaying ? '#FFF' : null,
      "aria-label": "Play/Stop",
      animated: props.isPlaying,
      flat: true
    }, extraProps, {
      id: "play-shape-button--button-".concat(props['data-id'])
    }), props.isPlaying ? React.createElement(Icon, {
      color: "background.pureWhite"
    }, React.createElement(Spotify, null)) : React.createElement(Icon, {
      color: "background.pureWhite",
      ml: "1px"
    }, React.createElement(Play, null))));
  });
});
const _MusicManager$propTyp = MusicManager.propTypes,
  {
    children
  } = _MusicManager$propTyp,
  PlayButtonProps = _objectWithoutProperties(_MusicManager$propTyp, ["children"]);
PlayShapeButton.propTypes = process.env.NODE_ENV !== "production" ? PlayButtonProps : {};
PlayShapeButton.defaultProps = MusicManager.defaultProps;